const initialState = { 
  loading: false,
  success: null,
  error: null
}

function saveCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_CATEGORY_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'SAVE_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'SAVE_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default saveCategoryReducer